var render = function (_h,_vm) {var _c=_vm._c;return _c('picture',[_c('source',{attrs:{"type":"image/webp","srcset":_vm.props.webp || _vm.props.data[_vm.props.webpKey],"alt":_vm.props.alt}}),_c('img',{attrs:{"src":_vm.props.src || _vm.props.data[_vm.props.srcKey],"alt":_vm.props.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }